<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Popups"
                icon="el-icon-news"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </template>
            </MacroSubHeader>

            <CardBase>
                <PopupList ref="popupList"/>
            </CardBase>
        </CardBase>

        <!-- PopupCreate -->
        <PopupCreateModal ref="popupCreateModal" @created="handleDispatch"/>
    </div>
</template>
<script>    
    //Components
    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";

    import PopupList from "@/components/_macro/popup/PopupList.vue";
    import PopupCreateModal from "@/components/_macro/popup/PopupCreateModal.vue";

    export default {
        name: "banners",
        data() {
            return {}
        },
        methods: {
            openModal() {
                this.$refs.popupCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.popupList.fetch();
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            PopupList,
            PopupCreateModal,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/configuracoes/popup/Index.vue